import getConfig from 'next/config';

export const getGalleryInteractionsBucketedCookie = (): string => {
  const {
    publicRuntimeConfig: { GALLERY_INTERACTION_EXPERIMENT_KEY },
  } = getConfig();
  return `convert_bucketed_${GALLERY_INTERACTION_EXPERIMENT_KEY}`;
};
